import { useState } from 'react';

const mockTradesList = [];

export default function useTradeListItemsInClosingOutBid() {
  // API call for closing high bid page
  return useState(() => mockTradesList);
}
